(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-v4"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-header]').forEach(function (header) {
    var drawer = header.querySelector('[data-drawer]');
    var overlay = header.querySelector('[data-drawer-overlay]');
    var openPanelBtns = header.querySelectorAll('[data-open-panel]');
    var backBtns = header.querySelectorAll('[data-back-to]');
    var closeBtns = header.querySelectorAll('[data-drawer-close]');
    var panels = header.querySelectorAll('[data-panel]');

    function showPanel(panelId) {
      panels.forEach(function (p) {
        if (p.dataset.panel === panelId) {
          p.classList.add('is-active');
          p.scrollTop = 0;
        } else {
          p.classList.remove('is-active');
        }
      });
    }

    function openDrawer(panelId) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showPanel(panelId || 'root');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Reset all panels
      setTimeout(function () {
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
      }, 300);
    }

    // Open buttons (burger + nav items + child items)
    openPanelBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var panelId = btn.dataset.openPanel;
        if (drawer.classList.contains('is-open')) {
          // Drawer already open — just switch panels
          showPanel(panelId);
        } else {
          // Drawer closed — open and show panel
          openDrawer(panelId);
        }
      });
    });

    // Back buttons
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPanel(btn.dataset.backTo);
      });
    });

    // Close buttons
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Overlay click
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  /**
   * Check if a slide is within its scheduled date/time range
   * Returns true if the slide should be visible, false if it should be hidden
   */
  function isSlideWithinSchedule(slide) {
    var isScheduleEnabled = slide.dataset.scheduleEnabled === 'true';
    if (!isScheduleEnabled) return true; // No scheduling = always visible

    var startDateStr = slide.dataset.scheduleStart;
    var endDateStr = slide.dataset.scheduleEnd;

    // If no dates are set, show the slide
    if (!startDateStr && !endDateStr) return true;

    var now = new Date();
    var startDate = startDateStr ? new Date(startDateStr.replace(/\s/, 'T')) : null;
    var endDate = endDateStr ? new Date(endDateStr.replace(/\s/, 'T')) : null;

    // Check if current time is within the schedule
    if (startDate && now < startDate) return false; // Before start date
    if (endDate && now > endDate) return false;     // After end date

    return true; // Within valid date range
  }

  /**
   * Update visibility of all slides based on their schedules
   */
  function updateScheduleVisibility(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__dot'));
    var dotsContainer = root.querySelector('.hero-slider__dots');
    var arrowPrev = root.querySelector('[data-prev]');
    var arrowNext = root.querySelector('[data-next]');
    var activeCount = 0;

    slides.forEach(function (slide, index) {
      var isVisible = isSlideWithinSchedule(slide);
      var dot = dots[index];

      if (isVisible) {
        slide.classList.remove('is-scheduled-inactive');
        activeCount++;
        if (dot) {
          dot.classList.remove('is-scheduled-inactive');
          dot.style.display = ''; // Show the dot
        }
      } else {
        slide.classList.add('is-scheduled-inactive');
        if (dot) {
          dot.classList.add('is-scheduled-inactive');
          dot.style.display = 'none'; // Hide the dot completely
        }
      }
    });

    // Hide dots container if only 1 or 0 active slides
    if (dotsContainer) {
      if (activeCount <= 1) {
        dotsContainer.style.display = 'none';
      } else {
        dotsContainer.style.display = 'flex';
      }
    }

    // Hide arrows if only 1 or 0 active slides
    if (arrowPrev) {
      arrowPrev.style.display = activeCount > 1 ? '' : 'none';
    }
    if (arrowNext) {
      arrowNext.style.display = activeCount > 1 ? '' : 'none';
    }
  }

  /**
   * Get the next visible slide (skipping scheduled-inactive ones)
   */
  function getNextVisibleSlide(slides, currentIndex, direction) {
    var length = slides.length;
    var index = currentIndex;
    var attempts = 0;

    while (attempts < length) {
      index = direction === 'next' ? (index + 1) % length : (index - 1 + length) % length;
      if (!slides[index].classList.contains('is-scheduled-inactive')) {
        return index;
      }
      attempts++;
    }

    return currentIndex; // Return current if no visible slide found
  }

  function initSlider(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__dot'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var loop = root.dataset.loop === 'true';
    var current = 0;
    var timer = null;

    // Initial schedule check
    updateScheduleVisibility(root);

    function goTo(index) {
      // Skip to next visible slide if current is scheduled-inactive
      if (slides[index] && slides[index].classList.contains('is-scheduled-inactive')) {
        index = getNextVisibleSlide(slides, index, 'next');
      }

      if (index >= slides.length) { if (!loop) return; index = 0; }
      if (index < 0) { if (!loop) return; index = slides.length - 1; }

      // Make sure final destination is not scheduled-inactive
      if (slides[index] && slides[index].classList.contains('is-scheduled-inactive')) {
        index = getNextVisibleSlide(slides, index, 'next');
      }

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      current = index;
    }

    // Find first active slide to display
    var firstActiveIndex = 0;
    for (var i = 0; i < slides.length; i++) {
      if (!slides[i].classList.contains('is-scheduled-inactive')) {
        firstActiveIndex = i;
        break;
      }
    }
    goTo(firstActiveIndex);

    function next() { goTo(getNextVisibleSlide(slides, current, 'next')); }
    function prev() { goTo(getNextVisibleSlide(slides, current, 'prev')); }
    function startAutoplay() { if (!autoplay) return; stopAutoplay(); timer = setInterval(next, interval); }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        // Skip if dot is scheduled-inactive (display: none)
        if (dot.classList.contains('is-scheduled-inactive')) return;
        var idx = parseInt(dot.dataset.dot, 10);
        if (!isNaN(idx)) { goTo(idx); startAutoplay(); }
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) >= 40) { if (diff > 0) next(); else prev(); }
      startAutoplay();
    }, { passive: true });

    // Check schedule every minute to handle date/time changes
    setInterval(function () {
      updateScheduleVisibility(root);
      // If current slide became inactive, move to next visible
      if (slides[current] && slides[current].classList.contains('is-scheduled-inactive')) {
        goTo(getNextVisibleSlide(slides, current, 'next'));
      }
    }, 60000); // Check every minute

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.hero-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('.pdp-section').forEach(function(root){var galleryActivate=null;var gallery=root.querySelector('[data-gallery]');if(gallery){var mainSlides=gallery.querySelectorAll('[data-slide]');var thumbs=gallery.querySelectorAll('[data-thumb-target]');var videoIframe=gallery.querySelector('[data-video-iframe]');var modelViewer=gallery.querySelector('[data-model-viewer]');var closeButtons=gallery.querySelectorAll('[data-close-overlay]');var zoomWraps=gallery.querySelectorAll('[data-zoom-wrap]');zoomWraps.forEach(function(wrap){var zoomImage=wrap.dataset.zoomImage;if(!zoomImage)return;var preloader=new Image();preloader.src=zoomImage;wrap.addEventListener('mouseenter',function(){wrap.style.backgroundImage="url('"+zoomImage+"')";wrap.classList.add('is-zooming')});function clearZoom(){wrap.classList.remove('is-zooming');wrap.style.backgroundImage='';wrap.style.backgroundPosition='';wrap.style.backgroundColor=''}wrap.addEventListener('mouseleave',clearZoom);wrap.addEventListener('blur',clearZoom);wrap.addEventListener('mousemove',function(e){var rect=wrap.getBoundingClientRect();var x=((e.clientX-rect.left)/rect.width)*100;var y=((e.clientY-rect.top)/rect.height)*100;x=Math.max(0,Math.min(100,x));y=Math.max(0,Math.min(100,y));wrap.style.backgroundPosition=x+'% '+y+'%'})});var thumbsTrack=gallery.querySelector('[data-thumbs-track]');var thumbsViewport=gallery.querySelector('[data-thumbs-viewport]');var thumbPrev=gallery.querySelector('[data-thumb-prev]');var thumbNext=gallery.querySelector('[data-thumb-next]');var thumbScrollPos=0;function thumbStep(){var first=thumbsTrack.querySelector('.gal__thumb');if(!first)return 80;return first.offsetWidth+8}function updateThumbsCarousel(){if(!thumbsTrack||!thumbsViewport)return;var trackWidth=thumbsTrack.scrollWidth;var viewportWidth=thumbsViewport.offsetWidth;var maxScroll=Math.max(0,trackWidth-viewportWidth);if(thumbScrollPos>maxScroll)thumbScrollPos=maxScroll;if(thumbScrollPos<0)thumbScrollPos=0;thumbsTrack.style.transform='translateX(-'+thumbScrollPos+'px)';if(thumbPrev)thumbPrev.disabled=thumbScrollPos<=0;if(thumbNext)thumbNext.disabled=thumbScrollPos>=maxScroll;var hasOverflow=trackWidth>viewportWidth;if(thumbPrev)thumbPrev.style.display=hasOverflow?'':'none';if(thumbNext)thumbNext.style.display=hasOverflow?'':'none'}if(thumbPrev)thumbPrev.addEventListener('click',function(){thumbScrollPos-=thumbStep()*3;updateThumbsCarousel()});if(thumbNext)thumbNext.addEventListener('click',function(){thumbScrollPos+=thumbStep()*3;updateThumbsCarousel()});window.addEventListener('resize',updateThumbsCarousel);setTimeout(updateThumbsCarousel,50);function activateSlide(target){mainSlides.forEach(function(s){s.classList.toggle('is-active',s.dataset.slide===target)});thumbs.forEach(function(t){t.classList.toggle('is-active',t.dataset.thumbTarget===target)});if(target==='video'&&videoIframe){var key=(videoIframe.dataset.youtubeKey||'').trim();var currentSrc=videoIframe.getAttribute('src')||'';if(key&&currentSrc.indexOf('youtube.com/embed/')===-1){videoIframe.setAttribute('src','https://www.youtube.com/embed/'+key+'?autoplay=1&rel=0&playsinline=1')}}else if(videoIframe){var currentSrc2=videoIframe.getAttribute('src')||'';if(currentSrc2.indexOf('youtube.com/embed/')!==-1){videoIframe.setAttribute('src','')}}if(target==='model'&&modelViewer){var glbSrc=(modelViewer.dataset.glbSrc||'').trim();var currentGlb=modelViewer.getAttribute('src')||'';if(glbSrc&&currentGlb==='')modelViewer.setAttribute('src',glbSrc)}}galleryActivate=activateSlide;thumbs.forEach(function(thumb){thumb.addEventListener('click',function(){activateSlide(thumb.dataset.thumbTarget)})});closeButtons.forEach(function(btn){btn.addEventListener('click',function(){activateSlide('0')})})}var qtyInput=root.querySelector('[data-qty-input]');var qtyDec=root.querySelector('[data-qty-decrement]');var qtyInc=root.querySelector('[data-qty-increment]');function updateSubtotal(){var priceEl=root.querySelector('[data-product-price]');var subtotalEl=root.querySelector('[data-subtotal]');if(!priceEl||!subtotalEl||!qtyInput)return;var qty=parseInt(qtyInput.value,10)||1;var raw=priceEl.textContent.trim();var prefixMatch=raw.match(/^[^\d-]+/);var prefix=prefixMatch?prefixMatch[0]:'$';var suffixMatch=raw.match(/[^\d.,]+$/);var suffix=suffixMatch?suffixMatch[0]:'';var priceText=raw.replace(/[^0-9.,-]/g,'').replace(/,/g,'');var price=parseFloat(priceText)||0;var total=price*qty;var totalStr=total.toFixed(2);var parts=totalStr.split('.');parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');subtotalEl.textContent=prefix+parts.join('.')+suffix}if(qtyInput&&qtyDec&&qtyInc){qtyDec.addEventListener('click',function(){var val=parseInt(qtyInput.value,10)||1;if(val>1)qtyInput.value=val-1;updateSubtotal()});qtyInc.addEventListener('click',function(){var val=parseInt(qtyInput.value,10)||1;qtyInput.value=val+1;updateSubtotal()});qtyInput.addEventListener('change',updateSubtotal)}var variantData=[];var variantJsonEl=root.querySelector('[data-variant-json]');if(variantJsonEl){try{variantData=JSON.parse(variantJsonEl.textContent)}catch(err){variantData=[]}}function getSelectedOptions(){var opts=[];root.querySelectorAll('.pdp__option').forEach(function(optEl){var sel=optEl.querySelector('.is-selected[data-option-value]');var idx=parseInt(optEl.dataset.optionIndex,10);if(sel&&!isNaN(idx))opts[idx]=sel.dataset.optionValue});return opts}function updateVariantUI(updateUrl){if(!variantData.length)return;var opts=getSelectedOptions();if(!opts.length)return;var match=null;for(var i=0;i<variantData.length;i++){var v=variantData[i];var ok=true;for(var j=0;j<opts.length;j++){if(typeof opts[j]!=='undefined'&&String(v.options[j])!==String(opts[j])){ok=false;break}}if(ok){match=v;break}}var addBtn=root.querySelector('[data-add-btn]');var addSpan=addBtn?addBtn.querySelector('span'):null;if(!match){if(addBtn){addBtn.disabled=true;if(addSpan)addSpan.textContent='Unavailable'}return}var idInput=root.querySelector('[data-variant-id]');if(idInput)idInput.value=match.id;var priceEl=root.querySelector('[data-product-price]');if(priceEl)priceEl.textContent=match.price_formatted;var hasCompare=match.compare_at_price>match.price;var compareEl=root.querySelector('[data-compare-price]');if(compareEl){compareEl.textContent=match.compare_formatted;if(hasCompare){compareEl.removeAttribute('hidden')}else{compareEl.setAttribute('hidden','')}}var badge=root.querySelector('[data-compare-badge]');if(badge){if(hasCompare){var bc=badge.querySelector('[data-badge-compare]');if(bc)bc.textContent=match.compare_formatted;var bp=badge.querySelector('[data-badge-pct]');if(bp)bp.textContent=Math.round((match.compare_at_price-match.price)*100/match.compare_at_price);badge.removeAttribute('hidden')}else{badge.setAttribute('hidden','')}}var skuWrap=root.querySelector('[data-sku-wrap]');var skuEl=root.querySelector('[data-sku]');if(skuEl){if(match.sku){skuEl.textContent=match.sku;if(skuWrap)skuWrap.removeAttribute('hidden')}else if(skuWrap){skuWrap.setAttribute('hidden','')}}var unitEl=root.querySelector('[data-unit-each]');if(unitEl&&match.unit_each_formatted){unitEl.textContent='('+match.unit_each_formatted+' '+(unitEl.dataset.unitLabel||'each')+')'}if(addBtn){addBtn.disabled=!match.available;if(addSpan)addSpan.textContent=match.available?(addBtn.dataset.addLabel||'Add to Cart'):(addBtn.dataset.soldoutLabel||'Sold Out')}if(galleryActivate){if(match.media){var slideEl=root.querySelector('[data-slide="'+match.media+'"]');if(slideEl){galleryActivate(match.media)}else{galleryActivate('0')}}else{galleryActivate('0')}}if(updateUrl&&window.history&&window.history.replaceState){try{var u=new URL(window.location.href);u.searchParams.set('variant',match.id);window.history.replaceState({},'',u.toString())}catch(err2){}}updateSubtotal()}var optionBtns=root.querySelectorAll('[data-option-position]');optionBtns.forEach(function(btn){btn.addEventListener('click',function(){var pos=btn.dataset.optionPosition;var siblings=root.querySelectorAll('[data-option-position="'+pos+'"]');siblings.forEach(function(sib){sib.classList.toggle('is-selected',sib===btn)});var selectedSpan=root.querySelector('[data-option-selected="'+pos+'"]');if(selectedSpan)selectedSpan.textContent=btn.dataset.optionValue;var optWrap=btn.closest('.pdp__option');if(optWrap){var chip=optWrap.querySelector('.pdp__option-selected-swatch');if(chip&&btn.classList.contains('pdp__swatch')){chip.style.backgroundColor=window.getComputedStyle(btn).backgroundColor}}updateVariantUI(true)})});updateVariantUI(false);var wishlistBtn=root.querySelector('[data-wishlist-btn]');if(wishlistBtn)wishlistBtn.addEventListener('click',function(){wishlistBtn.classList.toggle('is-active')});var accContainer=root.querySelector('[data-pdp-accordion]');if(accContainer){var accTriggers=accContainer.querySelectorAll('[data-acc-trigger]');var keepMultipleOpen=accContainer.dataset.multiple==='true';accTriggers.forEach(function(trigger){trigger.addEventListener('click',function(){var item=trigger.closest('.pdp-acc__item');var isOpen=item.classList.contains('is-open');if(!keepMultipleOpen&&!isOpen){accContainer.querySelectorAll('.pdp-acc__item.is-open').forEach(function(other){if(other!==item){other.classList.remove('is-open');var ot=other.querySelector('[data-acc-trigger]');if(ot)ot.setAttribute('aria-expanded','false')}})}item.classList.toggle('is-open');trigger.setAttribute('aria-expanded',item.classList.contains('is-open')?'true':'false')})})}});function openModal(modalId){var modal=document.querySelector('[data-modal="'+modalId+'"]');if(!modal)return;modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}function closeAllModals(){document.querySelectorAll('.pdp-modal.is-open').forEach(function(m){m.classList.remove('is-open');m.setAttribute('aria-hidden','true')});document.body.style.overflow=''}document.querySelectorAll('[data-open-modal]').forEach(function(btn){btn.addEventListener('click',function(e){e.preventDefault();openModal(btn.dataset.openModal)})});document.querySelectorAll('[data-modal-close]').forEach(function(btn){btn.addEventListener('click',closeAllModals)});document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAllModals()})})();
(function(){function norm(s){return String(s||'').toLowerCase().replace(/&amp;/g,' ').replace(/[–—\-,.()\/|:"'&+]/g,' ').split(/\s+/).filter(Boolean).join(' ')}function baseTitle(t,c){var x=' '+norm(t)+' ';if(x.slice(0,5)===' the ')x=' '+x.slice(5);var cn=norm(c);if(cn)x=x.split(' '+cn+' ').join(' ');return norm(x)}function hexFor(name,map){var out=[];function look(k){var n='|'+k+':';var i=map.indexOf(n);if(i<0)return'';return map.slice(i+n.length).split('|')[0]}String(name||'').toLowerCase().replace(/ & | and | y | with | con |,/g,'/').split('/').slice(0,2).forEach(function(p){p=p.trim();if(!p)return;var h=look(p);if(!h){var w=p.split(/\s+/).reverse();for(var i=0;i<w.length&&!h;i++)h=look(w[i])}if(h)out.push(h)});return out}function sized(u){if(!u)return'';if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width=120'}document.querySelectorAll('[data-similar-box]').forEach(function(box){var list=box.querySelector('[data-swatches]');var label=box.querySelector('[data-swatch-label]');if(!list)return;function selName(){var s=list.querySelector('.pdp__swatch.is-selected');return s?(s.dataset.colorName||''):''}list.addEventListener('mouseover',function(e){var sw=e.target.closest('.pdp__swatch');if(sw&&label)label.textContent=sw.dataset.colorName||sw.getAttribute('title')||''});list.addEventListener('mouseleave',function(){if(label)label.textContent=selName()});if(box.hasAttribute('data-no-search')||!window.fetch)return;var map=box.dataset.colorMap||'';var baseT=box.dataset.base||'';var title=box.dataset.title||'';if(!baseT||!title)return;var known=(box.dataset.known||'').split(',').filter(Boolean);var seen={};Array.prototype.forEach.call(list.querySelectorAll('[data-color-name]'),function(e){var k=norm(e.dataset.colorName);if(k)seen[k]=1});var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var words=baseT.split(' ');var q=root+'search/suggest.json?q='+encodeURIComponent(title)+'&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=last';fetch(q,{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null}).then(function(res){var prods=(res&&res.resources&&res.resources.results&&res.resources.results.products)||[];var cands=prods.filter(function(p){if(!p||!p.handle||known.indexOf(p.handle)>-1)return false;var n=' '+norm(p.title)+' ';return words.every(function(w){return n.indexOf(' '+w+' ')>-1})});return Promise.all(cands.map(function(p){return fetch(root+'products/'+p.handle+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})}))}).then(function(full){var added=0;(full||[]).forEach(function(p){if(!p||!p.variants||!p.variants.length||known.indexOf(p.handle)>-1)return;var ci=-1;(p.options||[]).forEach(function(o,i){var nm=typeof o==='string'?o:(o&&o.name)||'';if(ci<0&&/colo/i.test(nm))ci=i});var v=p.variants.filter(function(x){return x.available})[0]||p.variants[0];var color=(ci>-1&&v&&v.options)?(v.options[ci]||''):'';if(color==='Default Title')color='';if(baseTitle(p.title,color)!==baseT)return;var key=norm(color);if(key&&seen[key])return;if(key)seen[key]=1;known.push(p.handle);var nm=color||p.title;var a=document.createElement('a');a.href=root+'products/'+p.handle;a.className='pdp__swatch'+(p.available?'':' is-soldout');a.dataset.colorName=color;a.title=nm;a.setAttribute('aria-label',nm);var hx=hexFor(color,map);var img=sized((v&&v.featured_image&&v.featured_image.src)||p.featured_image||'');if(hx.length===1){a.style.background=hx[0]}else if(hx.length>1){a.style.background='linear-gradient(135deg,'+hx[0]+' 50%,'+hx[1]+' 50%)'}else{a.style.background='#b0ada8'}var sp=document.createElement('span');sp.className='visually-hidden';sp.textContent=nm;a.appendChild(sp);list.appendChild(a);added++});if(added)box.hidden=false}).catch(function(){})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-series-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-track]');
    var viewport = carousel.querySelector('[data-viewport]');
    var cards = carousel.querySelectorAll('[data-card]');
    var prevBtn = carousel.querySelector('[data-prev]');
    var nextBtn = carousel.querySelector('[data-next]');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;

    function getCardsPerView() {
      var width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 768) return 2;
      if (width <= 990) return 3;
      return parseInt(carousel.dataset.cardsPerView, 10) || 4;
    }

    function update() {
      var perView = getCardsPerView();
      var maxIndex = Math.max(0, cards.length - perView);
      if (currentIndex > maxIndex) currentIndex = maxIndex;

      var cardWidth = cards[0].offsetWidth;
      var gap = 16;
      var offset = currentIndex * (cardWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; update(); }
    });

    nextBtn.addEventListener('click', function () {
      var perView = getCardsPerView();
      var maxIndex = Math.max(0, cards.length - perView);
      if (currentIndex < maxIndex) { currentIndex++; update(); }
    });

    // Touch / swipe support
    var startX = 0;
    var deltaX = 0;
    var isDragging = false;

    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) nextBtn.click();
        else prevBtn.click();
      }
      deltaX = 0;
    });

    window.addEventListener('resize', update);
    update();

    // Variant option switching per card
    cards.forEach(function (card) {
      var variantInput = card.querySelector('[data-card-variant-id]');
      var variantsScript = card.querySelector('[data-card-variants]');
      var optionBtns = card.querySelectorAll('[data-option-position]');
      var addBtn = card.querySelector('.sc__add-btn');

      if (!variantsScript) return;

      var variants;
      try { variants = JSON.parse(variantsScript.textContent); }
      catch (e) { variants = []; }

      var selectedOptions = {};
      card.querySelectorAll('.sc__option-value.is-selected').forEach(function (btn) {
        selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
      });

      function findVariant() {
        return variants.find(function (v) {
          var options = [v.option1, v.option2, v.option3];
          for (var pos in selectedOptions) {
            if (options[parseInt(pos, 10)] !== selectedOptions[pos]) return false;
          }
          return true;
        });
      }

      optionBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = btn.dataset.optionPosition;
          card.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (sib) {
            sib.classList.toggle('is-selected', sib === btn);
          });
          var displaySpan = card.querySelector('[data-option-display="' + pos + '"]');
          if (displaySpan) displaySpan.textContent = btn.dataset.optionValue;

          selectedOptions[pos] = btn.dataset.optionValue;

          var newVariant = findVariant();
          if (newVariant && variantInput) {
            variantInput.value = newVariant.id;
            if (addBtn) {
              if (newVariant.available) {
                addBtn.disabled = false;
                addBtn.textContent = addBtn.dataset.addLabel || addBtn.textContent.trim();
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
